module.exports = __webpack_public_path__ + "img/Small_svante.c4f206f4.png";